module.exports = __webpack_public_path__ + "img/aqmola2.def3b2d4.jpg";